<template>
    <div>
        <div class="info-box">
            <div class="card-box">
                <div class="card-left">
                    <p>开课周数</p>
                    <p><span class="molecule">{{ openCourseData.currentWeek || 0 }}/</span><span class="denominator">{{
                            openCourseData.totalWeek||0 }}</span></p>
                </div>
                <div class="card-right">
                    <div class="item">
                        <div>学习人数</div>
                        <div>{{ openCourseData.studyCount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>学习人次</div>
                        <div>{{ openCourseData.studyNumberCount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>人均学习时长(分)</div>
                        <div>{{ openCourseData.studyTimeAvgCount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>总学习时长(分)</div>
                        <div>{{ openCourseData.totalStudyTime || 0 }}</div>
                    </div>
                </div>
            </div>
            <div class="card-box">
                <div class="card-left">
                    <p>课程考试</p>
                    <p style="color: #23B899;">{{ courseTestData.courseExamCount || 0 }}</p>
                    <div>
                        <p>考试总题数:</p>
                        <p style="color: #23B899;">{{ courseTestData.questionsCount || 0 }}</p>
                    </div>
                </div>
                <div class="card-right">
                    <div class="item">
                        <div>参与考试人数</div>
                        <div style="color: #23B899;">{{ courseTestData.examCount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>参与考试次数</div>
                        <div style="color: #23B899;">{{ courseTestData.examNumberOfTimes || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>考试合格率</div>
                        <div style="color: #23B899;">{{ courseTestData.examPercentOfPass }}</div>
                    </div>
                </div>
            </div>
            <div style="display: flex;flex: 1;gap: 2rem;">
                <div class="small-card-box">
                    <p>教学单元</p>
                    <p>{{ UnitNumber }}</p>
                </div> 
                <div class="small-card-box">
                    <p>课程任务</p>
                    <p>{{ courseTaskNum }}</p>
                </div>
            </div>
            <div class="card-box" v-if="false">
                <div class="card-left">
                    <p>随堂测试</p>
                    <p style="color: #FE7C4B;">{{ classTestData.classroomTestCount || 0 }}</p>
                </div>
                <div class="card-right">
                    <div class="item">
                        <div>参与考试人数</div>
                        <div style="color: #FE7C4B;">{{ classTestData.testCount || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>参与考试次数</div>
                        <div style="color: #FE7C4B;">{{ classTestData.testNumberOfTimes || 0 }}</div>
                    </div>
                    <div class="item">
                        <div>考试合格率</div>
                        <div style="color: #FE7C4B;">{{ classTestData.testPercentOfPass }}</div>
                    </div>
                </div>
            </div>
            <div class="card-box" v-if="false">
                <div class="card-left">
                    <p>在线互动</p>
                    <p style="color: #6DD230;">28</p>
                </div>
                <div class="card-right">
                    <div class="item">
                        <div>参与互动人数</div>
                        <div style="color: #6DD230;">123</div>
                    </div>
                    <div class="item">
                        <div>参与互动次数</div>
                        <div style="color: #6DD230;">123</div>
                    </div>
                </div>
            </div>
            <div class="card-box" v-if="false">
                <div class="card-left">
                    <p>AI互动</p>
                    <p style="color: #8978FF;">16</p>
                </div>
                <div class="card-right">
                    <div class="item">
                        <div>参与互动人数</div>
                        <div style="color: #8978FF;">123</div>
                    </div>
                    <div class="item">
                        <div>参与任务次数</div>
                        <div style="color: #8978FF;">123</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="resource-box">
            <div class="first">
                <div>资源总量</div>
                <div>{{ total }}</div>
            </div>
            <div class="second">
                <div v-for="(item, index) in resourceStatistics" :key="index">
                    <div>{{ index }}</div>
                    <div>{{ item }}</div>
                    <div>
                        <span class="grey">占比</span>
                        <span class="percent">{{ computedRate(item, total) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetOpenCourseConditionStatistics, GetCourseTeachingUnit, GetCourseResStatistics, GetClassroomTestData, GetCourseExamData, GetCourseTaskCount } from '@/api/courseDetailStatistics';
export default {
    props: {
        id: {
            default: ''
        }
    },
    data() {
        return {
            /**资源统计 */
            resourceStatistics: {
                '虚拟仿真': 0,
                '课件': 0,
                '视频': 0,
                '动画': 0,
                '模型': 0,
                '图片': 0,
                '文档': 0,
            },
            /**资源总数 */
            total: 105,
            /**开课数据统计 */
            openCourseData: {},
            /**教学单元数量 */
            UnitNumber: 0,
            /**随堂测试数据 */
            classTestData: {},
            /**课程任务数量 */
            courseTaskNum: 0,
            /**课程考试数据 */
            courseTestData: {}
        }
    },
    computed: {
        detail() {
            return this.$store.state.course.courseDetailData.detail;
        },
        courseId() {
            return this.$route.query.id || this.id;
        }
    },
    methods: {
        /**计算百分比 */
        computedRate(num, total) {
            if (total == 0) {
                return '0%'
            }
            return (num / total * 100).toFixed(1) + '%';
        },
        /**获取课程任务数量 */
        getCourseTaskCount() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetCourseTaskCount(params).then(res => {
                if (res.code == 200) {
                    this.courseTaskNum = res.data;
                }
            })
        },
        /**获取开课数据统计 */
        getOpenCourseConditionStatistics() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetOpenCourseConditionStatistics(params).then(res => {
                if (res.code == 200) {
                    this.openCourseData = res.data || {};
                }
            })
        },
        /**获取课程教学单元数量 */
        getCourseTeachingUnit() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetCourseTeachingUnit(params).then(res => {
                if (res.code == 200) {
                    this.UnitNumber = res.data;
                }
            })
        },
        /**获取课程资源统计 */
        getCourseResStatistics() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetCourseResStatistics(params).then(res => {
                if (res.code == 200) {
                    let total = 0;
                    res.data.forEach(item => {
                        total = total + item.resCount;
                        if (item.resType == 'ppt') {
                            this.resourceStatistics['课件'] = item.resCount;
                        } else if (item.resType == '仿真软件') {
                            this.resourceStatistics['虚拟仿真'] = item.resCount;
                        } else {
                            this.resourceStatistics[item.resType] = item.resCount;
                        }
                    })
                    this.total = total;
                }
            })
        },
        /**获取随堂测试数据 */
        getClassroomTestData() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetClassroomTestData(params).then(res => {
                if (res.code == 200) {
                    this.classTestData = res.data;
                }
            })
        },
        /**获取课程考试数据 */
        getCourseExamData() {
            var params = {
                courseId: this.courseId,
                openCourseId: this.detail.openCourseId
            }
            GetCourseExamData(params).then(res => {
                if (res.code == 200) {
                    this.courseTestData = res.data;
                }
            })
        },
    },
    mounted() {
        this.getOpenCourseConditionStatistics();
        this.getCourseTeachingUnit();
        this.getCourseResStatistics();
        this.getClassroomTestData();
        this.getCourseExamData();
        this.getCourseTaskCount();
    }
}
</script>

<style lang="less" scoped>
.info-box {
    display: flex;
    flex-wrap: wrap;
    color: #334681;
    gap: 2rem;

    &> :nth-child(n) {
        display: flex;
    }

    &> :nth-child(n+5) {
        margin-top: 2rem;
    }

    &> :nth-child(1),
    &> :nth-child(5) {
        margin-left: 0;
    }
}

.card-box {
    width: calc((100% - 4rem)/3);
    height: 18rem;
    border: 1px solid #e9ecf2;
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231, 236, 239, 0.10);

    .card-left {
        margin: 3rem 0;
        padding: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: calc(100% - 6rem);
        border-right: 1px solid #E9ECF2;

        &> :nth-child(1) {
            font-size: 16px;
        }

        &> :nth-child(2) {
            font-size: 2.6rem;
            font-weight: 700;
            margin-top: 0.5rem;
        }

        &> :nth-child(3) {
            display: flex;
            margin-top: 0.5rem;

            &> :nth-child(1) {
                color: #334681;
            }

            &> :nth-child(2) {
                font-weight: 600;
            }
        }
    }

    .card-right {
        flex: 1;
        padding: 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 12px;

        .item {
            display: flex;
            justify-content: space-between;
            margin-top: 1.5rem;

            &> :nth-child(1) {
                color: #8590B3;
            }

            &> :nth-child(2) {
                color: #387DFF;
                font-weight: 600;
            }
        }

        &> :nth-child(1) {
            margin-top: 0;
        }
    }
}

.small-card-box {
    flex: 1;
    height: 18rem;
    border: 1px solid #e9ecf2;
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231, 236, 239, 0.10);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &> :nth-child(1) {
        font-size: 16px;
    }

    &> :nth-child(2) {
        font-size: 2.6rem;
        font-weight: 700;
        color: #D5698A;
        margin-top: 0.5rem;
    }
}

.molecule {
    color: #387DFF;
}

.denominator {
    color: #334681;
}

.resource-box {
    border: 1px solid #e8ecef;
    border-radius: 10px;
    height: 18rem;
    margin: 3rem 0;
    display: flex;
}

.first {
    margin: 5rem 0;
    padding: 0 5rem;
    border-right: 1px solid #E9ECF2;
    color: #334681;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &> :nth-child(2) {
        color: #387DFF;
        font-weight: 600;
        font-size: 2.6rem;
    }
}

.second {
    flex: 1;
    display: flex;
    color: #334681;
    font-size: 12px;
    row-gap: 3rem;
    flex-wrap: wrap;
    &> :nth-child(n) {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &> :nth-child(3) {
            margin-top: 1rem;
        }

        &> :nth-child(2) {
            font-size: 2.6rem;
            color: #387DFF;
            font-weight: 700;
            margin-top: 1rem;
        }

        .grey {
            color: #8590B3;
        }

        .percent {
            color: #387DFF;
        }
    }
}

@media screen and (max-width:900px) {
    .info-box {
        flex-direction: column;
    }

    .card-box {
        width: 100%;
    }
    .resource-box{
        display: block;
        height: auto;
        .second{
            margin-bottom: 5rem;
            &> :nth-child(n){
                flex: none;
                width: calc(100% / 3);
            }
        }
    }
}
</style>